import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { login as loginApi } from './api/auth';
import './Auth.css';

const AUTH_TOKEN_KEY = 'access_token';
const AUTH_USER_KEY = 'user';
const REMEMBER_ACCOUNT_KEY = 'remember_account';

const Login = () => {
  const navigate = useNavigate();
  const [account, setAccount] = useState(
    () => localStorage.getItem(REMEMBER_ACCOUNT_KEY) || ''
  );
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(
    () => !!localStorage.getItem(REMEMBER_ACCOUNT_KEY)
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await loginApi(account.trim(), password);

      localStorage.setItem(AUTH_TOKEN_KEY, data.access_token);
      localStorage.setItem(AUTH_USER_KEY, JSON.stringify(data));

      if (remember) {
        localStorage.setItem(REMEMBER_ACCOUNT_KEY, account.trim());
        localStorage.setItem('auth_remember', '1');
      } else {
        localStorage.removeItem(REMEMBER_ACCOUNT_KEY);
        localStorage.removeItem('auth_remember');
      }

      navigate('/console');
    } catch (err) {
      setError(err.message || '登录失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <aside className="auth-brand">
        <div className="auth-brand-inner">
          <Link to="/dashboard" className="auth-logo">
            <span className="auth-logo-icon">T</span>
            TokenAI
          </Link>
          <h1>
            开启你的
            <br />
            <span className="gradient">AI 开发之旅</span>
          </h1>
          <p className="auth-brand-desc">
            一站式 AI 模型调用平台，提供 50+ 主流模型的统一接入服务，让你的应用更智能。
          </p>
          <div className="auth-stats">
            <div>
              <div className="auth-stat-value">99.9%</div>
              <div className="auth-stat-label">服务可用性</div>
            </div>
            <div>
              <div className="auth-stat-value">&lt;100ms</div>
              <div className="auth-stat-label">平均响应延迟</div>
            </div>
          </div>
        </div>
        <p className="auth-brand-footer">TokenAI - 新一代 AI 令牌服务平台</p>
      </aside>

      <div className="auth-form-panel">
        <div className="auth-form-top">
          <Link to="/dashboard" className="auth-logo-mobile">
            <span className="auth-logo-icon">T</span>
            TokenAI
          </Link>
          <Link to="/dashboard" className="auth-back-home">
            ← 返回首页
          </Link>
        </div>

        <div className="auth-form-body">
          <div className="auth-form-wrap">
            <div className="auth-form-header">
              <h2>欢迎回来</h2>
              <p>登录你的账户以继续</p>
            </div>

            <div className="auth-oauth">
              <button type="button" className="auth-oauth-btn">
                <span className="auth-oauth-icon">⬡</span>
                GitHub
              </button>
              <button type="button" className="auth-oauth-btn">
                <span className="auth-oauth-icon">G</span>
                Google
              </button>
            </div>

            <div className="auth-divider">或使用邮箱登录</div>

            <form className="auth-form" onSubmit={handleSubmit}>
              {error && <div className="auth-error">{error}</div>}

              <div className="auth-field">
                <label htmlFor="account">账号或邮箱</label>
                <input
                  id="account"
                  type="text"
                  placeholder="请输入账号或邮箱"
                  value={account}
                  onChange={(e) => setAccount(e.target.value)}
                  autoComplete="username"
                  disabled={loading}
                  required
                />
              </div>

              <div className="auth-field">
                <label htmlFor="password">密码</label>
                <input
                  id="password"
                  type="password"
                  placeholder="请输入密码"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  disabled={loading}
                  required
                />
              </div>

              <label className="auth-checkbox-row">
                <input
                  type="checkbox"
                  checked={remember}
                  onChange={(e) => setRemember(e.target.checked)}
                  disabled={loading}
                />
                记住账号和密码
              </label>

              <button type="submit" className="auth-submit" disabled={loading}>
                {loading ? '登录中…' : '登录'}
              </button>
            </form>

            <p className="auth-form-footer">
              还没有账户？<Link to="/register">立即注册</Link>
            </p>
          </div>
        </div>

        <p className="auth-form-bottom">TokenAI - 新一代 AI 令牌服务平台</p>
      </div>
    </div>
  );
};

export default Login;
